import { put, call, takeLatest, fork, all, select } from 'redux-saga/effects';
import { callApi, createReducer, createAction } from 'dorothy/utils';
import * as type from './constant';

function* addPost(action) {
  const { callback, form } = action.payload;
  try {
    const response = yield call(callApi, 'POST', `/api/posts`, form);

    if (response) {
      yield put(createAction(type.ADD_POST_RESPONSE, response));
      callback(true);
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.POST_REQUEST_ERROR));
  }
}

function* getPost(action) {
  const { id } = action.payload;
  try {
    const response = yield call(callApi, 'GET', `/api/posts/${id}`);

    if (response) {
      yield put(createAction(type.GET_POST_RESPONSE, response));
      // callback(response);
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.GET_REQUEST_ERROR));
  }
}

function* getPosts(action) {
  let { skip } = action.payload;
  const searchValue = yield select(state => state.post.searchValue);
  const language = yield select(state => state.post.language);
  const author = yield select(state => state.post.author);
  const datePublic = yield select(state => state.post.datePublic);
  const datePublicStart = yield select(state => state.post.datePublicStart);
  const datePublicEnd = yield select(state => state.post.datePublicEnd);

  try {
    let endpoint = `api/posts?skip=${skip}&pageSize=${type.PAGE_SIZE}`;
    if (searchValue) {
      endpoint = `${endpoint}&searchValue=${searchValue}`;
    }
    if (language) {
      endpoint = `${endpoint}&language=${language}`;
    }
    if (author !== null && author !== undefined) {
      endpoint = `${endpoint}&author=${author}`;
    }
    if (datePublic) {
      endpoint = `${endpoint}&datePublic=${datePublic}`;
    }
    if (datePublicStart) {
      endpoint = `${endpoint}&datePublicStart=${datePublicStart}`;
    }
    if (datePublicEnd) {
      endpoint = `${endpoint}&datePublicEnd=${datePublicEnd}`;
    }

    const response = yield call(callApi, 'GET', endpoint);

    if (response) {
      yield put(createAction(type.GET_LIST_POST_RESPONSE, {
        ...response, searchValue, language,
        author, datePublic, datePublicStart, datePublicEnd
      }));
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.GET_LIST_REQUEST_ERROR));
  }
}

function* getAuthors(action) {
  try {
    let endpoint = `/api/authors`;
    const response = yield call(callApi, 'GET', endpoint);

    if (response) {
      yield put(createAction(type.GET_LIST_AUTHOR_RESPONSE, response));
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.GET_LIST_AUTHOR_REQUEST_ERROR));
  }
}

function* deletePost(action) {
  const { id } = action.payload;
  try {
    const response = yield call(callApi, 'DELETE', `api/posts/${id}`);
    if (response) {
      yield put(createAction(type.DELETE_POST_RESPONSE, id));
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.DELETE_POST_ERROR));
  }
}

function* updatePost(action) {
  const { callback, form, postId } = action.payload;
  try {
    const response = yield call(callApi, 'PATCH', `/api/posts/${postId}`, form);

    if (response) {
      yield put(createAction(type.UPDATE_POST_RESPONSE, response));
      callback(true);
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.POST_REQUEST_ERROR));
  }
}

function* duplicatePost(action) {
  const { id, language, isReplaceLink } = action.payload;
  try {
    const response = yield call(callApi, 'GET', `api/posts/${id}`);
    if (response) {
      // const isDuplicated = yield call(callApi, 'POST', `/api/posts/validate`, {
      //   postId: id,
      //   title: response.title,
      //   languageTo: response.language
      // });
      // console.log('isDuplicated', isDuplicated);
      // if (isDuplicated) {
      //   yield put(createAction(type.VALIDATE_POST_RESPONSE, isDuplicated));
      //   return;
      // }
      response.postId = null;
      response.language = language;
      response.isReplaceLink = isReplaceLink;

      const post = yield call(callApi, 'POST', `/api/posts/copy`, response);
      if (post) {
        yield put(createAction(type.DUPLICATE_POST_RESPONSE, post));
      }
    }
  } catch (error) {
    console.log(error);
    yield put(createAction(type.DUPLICATE_POST_ERROR));
  }
}

// function* validatePost(action) {
//   const { postId, urlTitle, languageTo } = action.payload;
//   try {
//     // const response = yield call(callApi, 'POST', `/api/posts/validate`, {
//     //   postId, urlTitle, languageTo
//     // });

//     // if (response) {
//     //   yield put(createAction(type.VALIDATE_POST_RESPONSE, response));
//     //   return response;
//     // }
//   } catch (error) {
//     console.log(error);
//     yield put(createAction(type.VALIDATE_POST_ERROR));
//   }
// }


function* watchAddPost() {
  yield takeLatest(type.ADD_POST_REQUEST, addPost);
}

function* watchGetPost() {
  yield takeLatest(type.GET_POST_REQUEST, getPost);
}

function* watchGetPosts() {
  yield takeLatest(type.GET_LIST_POST_REQUEST, getPosts);
}

function* watchDeletePost() {
  yield takeLatest(type.DELETE_POST_REQUEST, deletePost);
}

function* watchUpdatePost() {
  yield takeLatest(type.UPDATE_POST_REQUEST, updatePost);
}

function* watchDuplicatePost() {
  yield takeLatest(type.DUPLICATE_POST_REQUEST, duplicatePost);
}

// function* watchValidatePost() {
//   yield takeLatest(type.VALIDATE_POST_REQUEST, validatePost);
// }

function* watchGetAuthors() {
  yield takeLatest(type.GET_LIST_AUTHOR_REQUEST, getAuthors);
}

const initPost = {
  isWaitingSave: false,
  postDetail: null,
  authors: null,
  isGetPosts: false,
  listPost: { data: [] },
  isGetLoadMorePosts: false,
  isDeletePost: false,
  skip: 0,
};
const postActionHandlers = {
  [type.ADD_POST_REQUEST]: (state, action) => ({ ...state, isWaitingSave: true }),

  [type.ADD_POST_RESPONSE]: (state, action) => {
    return { ...state, isWaitingSave: false };
  },
  [type.POST_REQUEST_ERROR]: (state, action) => {
    return { ...state, isWaitingSave: false };
  },
  [type.GET_POST_REQUEST]: (state, action) => ({ ...state, isLoadingPost: true }),
  [type.GET_POST_RESPONSE]: (state, action) => ({
    ...state,
    postDetail: action.payload,
    isLoadingPost: false,
  }),
  [type.GET_REQUEST_ERROR]: (state, action) => state,
  [type.GET_LIST_POST_REQUEST]: (state, action) => ({ ...state, isLoadingPosts: true }),
  [type.GET_LIST_POST_RESPONSE]: (state, action) => {
    const { data, totalCount, skip } = action.payload;
    let newData = [];
    if (+skip === 0) {
      newData = [...data];
    } else {
      newData = [...state.listPost.data, ...data];
    }

    return {
      ...state,
      isLoadingPosts: false,
      listPost: {
        data: newData,
        totalCount,
      },
    };
  },
  [type.GET_LIST_REQUEST_ERROR]: (state, action) => state,
  [type.DELETE_POST_REQUEST]: (state, action) => state,
  [type.DELETE_POST_RESPONSE]: (state, action) => {
    const postId = action.payload;
    const data = state.listPost.data.filter(item => item.postId !== postId);
    return {
      ...state,
      listPost: {
        data,
        totalCount: state.listPost.totalCount,
        // skip: state.listPost.skip,
      },
    };
  },
  [type.DELETE_POST_ERROR]: (state, action) => state,
  [type.UPDATE_POST_REQUEST]: (state, action) => {
    return { ...state, isWaitingSave: true };
  },
  [type.UPDATE_POST_RESPONSE]: (state, action) => {
    return { ...state, isWaitingSave: false };
  },
  [type.UPDATE_SKIP]: (state, action) => {
    return { ...state, skip: action.payload };
  },
  [type.Update_SEARCH_VALUE]: (state, action) => {
    return { ...state, searchValue: action.payload };
  },
  [type.GET_LIST_AUTHOR_REQUEST]: (state, action) => ({ ...state, isLoadingPosts: true }),
  [type.GET_LIST_AUTHOR_RESPONSE]: (state, action) => ({
    ...state,
    authors: action.payload,
    isLoadingPost: false,
  }),
  [type.GET_LIST_AUTHOR_REQUEST_ERROR]: (state, action) => state,
  [type.UPDATE_FILTER]: (state, action) => {
    return { ...state, ...action.payload };
  },
  [type.GET_FILTER]: (state, action) => {
    return {
      searchValue: state.searchValue,
      language: state.language,
      author: state.author,
      datePublicStart: state.datePublicStart,
      datePublicEnd: state.datePublicEnd,
    };
  },

  [type.DUPLICATE_POST_REQUEST]: (state, action) => state,
  [type.DUPLICATE_POST_RESPONSE]: (state, action) => {
    const postData = action.payload;
    state.listPost.data.unshift(postData);
    return {
      ...state,
      listPost: {
        data: state.listPost.data,
        totalCount: state.listPost.totalCount,
        // skip: state.listPost.skip,
      },
    };
  },
  // [type.VALIDATE_POST_REQUEST]: (state, action) => state,
  // [type.VALIDATE_POST_RESPONSE]: (state, action) => {
  //   return state;
  // },
};

export const postReducer = createReducer(initPost, postActionHandlers);
export const postSagas = function* postSagas() {
  yield all[
    (yield fork(watchAddPost),
      yield fork(watchGetPost),
      yield fork(watchGetPosts),
      yield fork(watchDeletePost),
      yield fork(watchUpdatePost),
      yield fork(watchDuplicatePost),
      // yield fork(watchValidatePost),
      yield fork(watchGetAuthors))
  ];
};
